const config = window.gMapConfig || {};

export const HALL_URLTYPE = config.HALL_URLTYPE || '';
export const HALL_APPID = config.HALL_APPID || '';

//#大厅管理地址 -- 微信代理
export const WECHAT_URL = config.WECHAT_URL || '';
export const WECHAT_SYS = config.WECHAT_SYS || '';

//#大厅管理地址 -- 直接连接
export const service_url = config.service_url || '';
export const extraWindows_url = config.extraWindows_url || '';

// 在线预约，办事指南
export const bsznUrl = config.bsznUrl || '';
export const zxblUrl = config.zxblUrl || '';
export const zxyyUrl = config.zxyyUrl || '';

// 是否展示二维码
export const showQrcode = config.showQrcode || false;

// 默认城市
export const defaultCity = config.defaultCity || {};

// 城市区划
export const configArea = config.configArea || {};

export const accessToken = '422EC406A5AC420C8DB60E5C7EB6D91D'
export const INVOKESERVICE_CODE = config.INVOKESERVICE_CODE;
export const INVOKECALLER_CODE = config.INVOKECALLER_CODE;



